import styled from '@emotion/styled';
import { FC } from 'react';
import Text from 'components/base/Text';
import { ProductCardProps, ProductUbl } from 'components/common/ProductCard';
import ProductCardList from 'components/common/ProductCardList';
import { bg_secondary } from 'styles';

interface Props {
  product_list: ProductCardProps[];
  product_ubl?: ProductUbl;
  column: number;
}

/**
 * 광고 상품 리스트 영역
 * @component
 */
const AdProductList: FC<Props> = ({ product_list, product_ubl, column }) => {
  return (
    <SC.Container>
      <SC.TopInfo>
        <Text variant='title6_medium' color='gray_secondary'>
          당신을 위한 추천 상품
        </Text>
        <Text className='sponser' variant='small1_regular' color='border1' alignment='right'>
          sponsored
        </Text>
      </SC.TopInfo>
      <ProductCardList
        padding='0 16px 4px'
        card_size={column === 3 ? 'small' : 'medium'}
        column={column}
        product_list={product_list}
        product_ubl={product_ubl}
      />
    </SC.Container>
  );
};

export default AdProductList;

const SC = {
  Container: styled.section``,
  TopInfo: styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    margin-bottom: 4px;
  `,
  Bar: styled.div`
    width: 100%;
    height: 8px;
    background-color: ${bg_secondary};
    margin: 20px 0 4px;
  `,
};
